import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline'
import RightTooltip from '../RightTooltip'

interface UserInfoProps {
  collapsed?: boolean
}

const UserInfo: React.FC<UserInfoProps> = ({ collapsed }) => {
  const { user, isAuthenticated, isLoading, logout } = useAuth0()

  if (!isAuthenticated || isLoading) return null

  const handleLogout = () => {
    // Clear all Auth0-related data from localStorage to prevent stale user data
    const keysToRemove = []
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key && (key.startsWith('@@auth0spajs@@') || key === 'accessToken')) {
        keysToRemove.push(key)
      }
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key))

    // Clear session storage as well
    sessionStorage.clear()

    // Perform the logout
    logout({ logoutParams: { returnTo: window.location.origin } })
  }

  if (collapsed) {
    return (
      <div className="p-2 text-xs pointer-default text-slate-400 dark:text-slate-500 border-t border-slate-200 dark:border-slate-700 flex justify-center">
        <RightTooltip content={user?.email ? `Log out (${user.email})` : 'Log Out'}>
          <button
            onClick={handleLogout}
            aria-label="Log Out"
            className="cursor-pointer text-slate-500 dark:text-slate-300 hover:text-indigo-500 dark:hover:text-indigo-400 transition-colors duration-200"
          >
            <ArrowRightOnRectangleIcon className="w-5 h-5" />
          </button>
        </RightTooltip>
      </div>
    )
  }

  return (
    <div className="p-2 text-xs pointer-default text-slate-400 dark:text-slate-500 border-t border-slate-200 dark:border-slate-700">
      {user?.name && user?.name !== user?.email && (
        <div className="truncate font-semibold w-[170px] text-slate-500 dark:text-slate-400" title={user.name}>
          {user.name}
        </div>
      )}
      {user?.email && (
        <div className="truncate font-normal w-[170px] text-slate-500 dark:text-slate-400" title={user.email}>
          {user.email}
        </div>
      )}
      <a onClick={handleLogout}>
        <div className="inline cursor-pointer font-normal pt-1 transition-color duration-200 text-slate-500 dark:text-slate-300 hover:text-indigo-500 dark:hover:text-indigo-400 font-medium">
          Log Out
        </div>
      </a>
    </div>
  )
}

export default UserInfo
